import * as React from 'react';
export const LYSvg = React.forwardRef(function LYSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        fillRule: 'nonzero',
        d: 'M0 5h16v6H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M8 6.268a1.75 1.75 0 1 0 0 3.464 2 2 0 1 1 0-3.464ZM9 9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'M0 5V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M14 14H2a2 2 0 0 1-2-2v-1h16v1a2 2 0 0 1-2 2Z',
      }),
    ),
  );
});
LYSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var LY = {
  category: 'flag',
  colorable: false,
  name: 'LY',
  svg: LYSvg,
};
